module.exports = __webpack_public_path__ + "img/scene-highway.8b2f8b3a.jpg";